var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMswordFileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 2.375H5.54167C5.10427 2.375 4.75 2.72927 4.75 3.16667V5.93869H17.4167V3.16667C17.4167 2.72927 17.0624 2.375 16.625 2.375Z",
    fill: "url(#paint0_linear_2851_2100)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 13.084V15.8334C4.75 16.2708 5.10427 16.6251 5.54167 16.6251H16.625C17.0624 16.6251 17.4167 16.2708 17.4167 15.8334V13.084H4.75Z",
    fill: "url(#paint1_linear_2851_2100)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.93848H17.4167V9.50177H4.75V5.93848Z",
    fill: "url(#paint2_linear_2851_2100)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.50195H17.4167V13.0842H4.75V9.50195Z",
    fill: "url(#paint3_linear_2851_2100)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M8.8346 5.14551H4.75V14.6455H8.8346C9.63933 14.6455 10.2917 13.9932 10.2917 13.1884V6.60257C10.2917 5.79784 9.63933 5.14551 8.8346 5.14551Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M8.79265 14.2497H4.75V5.27734H8.79265C9.47506 5.27734 10.028 5.83032 10.028 6.51274V13.0143C10.0276 13.6967 9.47467 14.2497 8.79265 14.2497Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M8.75029 13.8545H4.75V5.41016H8.75029C9.31 5.41016 9.76363 5.86378 9.76363 6.42349V12.8411C9.76402 13.4008 9.31 13.8545 8.75029 13.8545Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70898 13.4587H2.37565C1.93826 13.4587 1.58398 13.1044 1.58398 12.667V6.33366C1.58398 5.89626 1.93826 5.54199 2.37565 5.54199H8.70898C9.14638 5.54199 9.50065 5.89626 9.50065 6.33366V12.667C9.50065 13.1044 9.14638 13.4587 8.70898 13.4587Z",
    fill: "url(#paint4_linear_2851_2100)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28535 7.52051L6.67339 10.3958L5.99533 7.52051H5.12964L4.4302 10.4849L3.79964 7.52051H3.02539L3.95322 11.4788H4.88422L5.56229 8.43528L6.24074 11.4788H7.13177L8.0596 7.52051H7.28535Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2851_2100",
    x1: 11.0833,
    y1: 5.92404,
    x2: 11.0833,
    y2: 2.55312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42A4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2851_2100",
    x1: 11.0833,
    y1: 16.6251,
    x2: 11.0833,
    y2: 13.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11408A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2851_2100",
    x1: 11.0833,
    y1: -6.11979,
    x2: 11.0833,
    y2: -6.14394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297CD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2851_2100",
    x1: 4.75,
    y1: 11.2931,
    x2: 17.4167,
    y2: 11.2931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D59B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2851_2100",
    x1: 1.87848,
    y1: 5.83649,
    x2: 9.30036,
    y2: 13.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1247AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMswordFileLogo);
export default __webpack_public_path__ + "static/media/mswordFile_logo.5cf05c60644e6bc9e894268634fe6de7.svg";
export { ForwardRef as ReactComponent };